var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$options._componentTag,attrs:{"id":_vm.id ? _vm.id : _vm.$options._componentTag + '-' + _vm._uid}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }